import React from 'react';
import { Empty, Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

const VariantEmptyState = ({ onAdd }) => {
    return (
        <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={
                <span style={{ color: '#64748b', fontWeight: 600 }}>
                    No Variant Groups Configured
                </span>
            }
            style={{ margin: '20px 0', background: '#f8fafc', padding: '40px', borderRadius: '12px', border: '1px dashed #cbd5e1' }}
        >
            <Button type="dashed" icon={<PlusOutlined />} onClick={onAdd} style={{ borderRadius: '8px', color: '#3b82f6', borderColor: '#3b82f6', fontWeight: 600, padding: '0 24px', height: '40px' }}>
                Create Custom Group
            </Button>
        </Empty>
    );
};

export default React.memo(VariantEmptyState);
